<template>
  <div>
    <div>
      <div id="header">
        <i class="el-icon-back" @click="goBack"></i>
        <h4>个人中心</h4>
        <i class="el-icon-switch-button" @click="logOff"></i>
      </div>
    </div>
    <div id="nickname">
      <div id="head" @click="changeHeadUrl">
        <img alt="" :src="headUrl" style='width:100%;height: 100%'></img>
        <div id="head_sh" v-if="headAudit" >
          审核中
        </div>
      </div>
      <div id="name">
        <!--        美好的一天开始了-->
      </div>
    </div>
    <ul class="vip-cnt">
      <li class="vip-cnt-li" @click="changeName">
        <div class="cnt-div1">
          <!--          <img src="../../static/img/vipcenter.png"style="width:.14rem;margin-right:.1rem;margin-top: -0.06rem;" alt="">-->
          <i class="el-icon-edit" style="width:.14rem;margin-right:.1rem;margin-top: -0.06rem;"></i> {{ nickName }}
        </div>
        <div class="cnt-div1" style="color:#aaa;font-size:.13rem;line-height:.6rem;">修改<img
            src="../../static/img/mor.png" style="width: .1rem;margin-left: .08rem;margin-top:-0.04rem;" alt=""></div>
      </li>
      <li class="vip-cnt-li" @click="exitLogin">
        <div class="cnt-div1">
          <i class="el-icon-setting" style="width:.14rem;margin-right:.1rem;margin-top: -0.06rem;"></i> 设置
        </div>
        <div class="cnt-div1" style="color:#aaa;font-size:.13rem;line-height:.6rem;">退出<img
            src="../../static/img/mor.png" style="width: .1rem;margin-left: .08rem;margin-top:-0.04rem;" alt=""></div>
      </li>
    </ul>

    <div id="nav" style="margin-top:.1rem;margin-bottom:.1rem;overflow: hidden;">
      <div>
        <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
      </div>
    </div>
    <div id="nav-char">
      <div>
        <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
      </div>
    </div>
    <el-dialog
        title="上传头像"
        :visible.sync="headDialog"
        width="80%"
        :before-close="handleClose">
<!--      <span>这是一段信息</span>-->
      <div style="display: flex;justify-content: space-around;">

        <div style="width: 1rem;height: 1rem;">
          <vue-cropper
              ref="cropper"
              :img="options.img"
              :info="true"
              :info-true="options.infoTrue"
              :auto-crop="options.autoCrop"
              :auto-crop-width="options.autoCropWidth"
              :auto-crop-height="options.autoCropHeight"
              :output-size="options.outputSize"
              :output-type="options.outputType"
              :fixed-box="options.fixedBox"
              :can-move-box="options.canMoveBox"
              :center-box="options.centerBox"
              :full="options.full"
              :fixed="options.fixed"
              :fixed-number="options.fixedNumber"
              @realTime="realTime"
          >
          </vue-cropper>
        </div>

        <div class="pre" style="width:1rem;height:1rem;margin-left: .1rem;overflow:hidden;border-radius: 1rem;border-color: #e0e0e0">
          <img :src="options.cut_img" style="width:100%;height: 100%;">
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="width:100%;display: flex;justify-content: space-around;">
         <el-upload
             class="avatar-uploader"
             :action="uploadUrl"
             :show-file-list="false"
             :on-success="handleAvatarSuccess"
             :before-upload="beforeAvatarUpload">
          <el-button  type="primary">选择图片</el-button>
        </el-upload>
        <el-button @click="cancelChangeHead">取 消</el-button>
        <el-button type="primary" @click="saveHead">保 存</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
export default {
  name: 'vip',
  data() {
    return {
      options: {
        img: '',  // 需要剪裁的图片
        cut_img:'',
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 150, // 默认生成截图框的宽度
        autoCropHeight: 150, // 默认生成截图框的长度
        fixedBox: true,// 是否固定截图框的大小 不允许改变
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量 [1至0.1]
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      previews: {}, // 裁剪之后的结果
      mescroll: null, //mescroll实例对象
      dataList: [], //列表数据
      huo: [],
      addDesk: false,
      nickName: '',
      headUrl: '',
      headAudit: false,
      userId: '',
      openId: '',
      accessToken: '',
      defaultHeadUrl: '../../static/img/moren.jpg',
      src: '',
      src_id: '',
      fromPath:'',
      logOffCode: '',
      headDialog:false,
      uploadImageUrl:'',
      uploadNew:false,
      uploadUrl: process.env.APP_API_URL + '/upload/head',
      fromWeather:false,
    }
  },

  methods: {
    edit (id) {
      this.visible = true
      this.id = id
    },
    close () {
      this.id = null
      this.visible = false
    },
    cancelHandel () {
      this.close()
    },
    // 图片放大/缩小
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    // 右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    beforeUpload (file) {
      const reader = new FileReader()
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        // 获取到需要剪裁的图片 展示到剪裁框中
        this.options.img = reader.result
      }
      this.uploadNew = true;
      return false
    },
    // 上传图片（点击保存按钮）
    finish (type) {
      this.$refs.cropper.getCropData((data) => {
        this.visible = false
        // data为base64图片，供接口使用
        this.$emit('save', data)
      })
    },
    // 裁剪之后的数据
    realTime () {
      let that = this;
      this.$refs.cropper.getCropData((data) => {
        that.options.cut_img = data;
        // console.log(that.options.cut_img)
      })

    },
    handleAvatarSuccess(res, file) {
      if(res && res.data){
        this.uploadImageUrl = res.data;
      }else{
        this.$message.error("上传失败");
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$toast.center('上传头像图片只能是 JPG或PNG 格式');
      }
      if (!isLt2M) {
        this.$toast.center('上传头像图片大小不能超过 10MB');
      }
      // this.$refs.cropper.changeScale(1.5);
      if(isJPG && isLt2M){
        return this.beforeUpload(file);
      }
      return false;
    },

    handleClose:function (done){
      let that = this;
      this.$confirm('确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'l_c_yes',
        cancelButtonClass: 'l_c_no',
        type: 'warning'
      }).then(() => {
        that.options.img = '';
        done();
      }).catch(() => {
      });
    },
    cancelChangeHead:function (){
      let that = this;
      this.$confirm('确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'l_c_yes',
        cancelButtonClass: 'l_c_no',
        type: 'warning'
      }).then(() => {
        that.options.img = '';
        that.headDialog  = false;
      }).catch(() => {
      });
    },
    openLogin:function (){
      if(this.fromPath && this.fromPath.length > 0 && this.src_id){
        this.$router.push({name: 'Login',query: {p: this.common.encodePath(this.fromPath),id:this.src_id}});
      }else if(this.fromPath){
        this.$router.push({name: 'Login',query: {p: this.common.encodePath(this.fromPath)}});
      }else if (this.src && this.src_id) {
        this.$router.push({name: 'Login',query: {src: this.common.encodePath(this.src),id:this.src_id}});
      } else if (this.src) {
        this.$router.push({name: 'Login',query: {src: this.common.encodePath(this.src)}});
      } else {
        this.$router.push({path: '/login'});
      }
    },
    goBack: function () {
      if(this.fromPath && this.fromPath.length > 0 && this.src_id){
        this.$router.replace({path:this.fromPath,query:{id:this.src_id}});
      }else if(this.fromPath){
        this.$router.replace({path:this.fromPath});
      }else if (this.src && this.src_id) {
        this.$router.push({name: this.src, query: {id: this.src_id}});
      } else if (this.src) {
        this.$router.push({name: this.src});
      } else {
        this.$router.push({path: '/'});
      }
    },
    initSrc: function () {
      if (this.$route.query.id) {
        this.src_id = this.$route.query.id;
      }
      if (this.$route.query.src) {
        this.src = this.common.decodePath(this.$route.query.src)
      }
      if(this.$route.query.p){
        this.fromPath = this.common.decodePath(this.$route.query.p)
      }
    },
    getDate: function () {
      this.userId = this.userTool.getUserId();
      this.uuid = this.common.getUUID();
      if (!this.userId || this.userId === '') {
        let path = this.common.encodePath("vip");
        this.$router.push({name: 'Login', query: {src: path, id: this.a}});
        return
      }
      // this.headUrl = this.userTool.getUserHeadUrl();
      // this.nickName = this.userTool.getUserNickname();
      if (!this.headUrl) {
        this.headUrl = this.defaultHeadUrl;
      }

      let params = {"uuid": this.uuid, "userId": this.userId};
      let t = new Date().getTime();
      let jiami = this.common.encodeParams(params, t);

      let apiUrl = process.env.APP_API_URL;

      this.$http.post(apiUrl + "/user/info", {data: jiami, t: t}
      ).then((response) => {
        // console.log(response);
        if (response.body.status === 1) {
          let user = response.body.data;
          if (user.tempNickName && user.tempNickName  !== '') {
            this.nickName = user.tempNickName + "(审核中)";
          }else{
            this.nickName = user.nickName;
            this.userTool.setUserNickName(this.nickName)
          }
          if (user.tempHeadUrl && user.tempHeadUrl  !== '') {
            this.headUrl = user.tempHeadUrl == null ? user.headUrl : user.tempHeadUrl;
            this.headAudit = true;
          }else{
            this.headUrl = user.headUrl;
            this.headAudit = false;
            this.userTool.setUserHeadUrl(this.headUrl)
          }
        } else if (response.body.status === -1) {
          this.$toast.center('用户信息异常！');
        }
      }).catch((e) => {
        this.$toast.center('用户信息异常！');
      })
    },
    checkName:function (value){
      if (!value || !value.match(/[\u4e00-\u9fa5_a-zA-Z0-9]{2,10}/)) {
        return '请输入2-10位英文或汉字' ;
      }else if (value.length < 2 || value.length > 10){
        return '请输入2-10位长度昵称' ;
      }
    },
    changeName:function (){
      this.$prompt('请输入新昵称', '编辑', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'l_c_yes',
        cancelButtonClass: 'l_c_no',
        closeOnClickModal:false,
        inputValidator: value => this.checkName(value),
      }).then(({value}) => {
        let params = {"nickName": value, "userId": this.userId, "uuid": this.uuid};
        let t = new Date().getTime();
        let data = this.common.encodeParams(params, t);
        let apiUrl = process.env.APP_API_URL;

        this.$http.post(apiUrl + "/user/change", {data: data, t: t}
        ).then((response) => {
          // console.log(response);
          if (response.body.status === 1) {
            this.$toast.center('修改成功，审核通过后自动更新');
            let user = response.body.data;
            if(user){
              this.nickName = user.tempNickName+"(审核中)";
            }
          } else if (response.body.status === -4) {
            this.$toast.center('昵称含有敏感词汇，请重试');
          } else  {
            this.$toast.center('修改失败！请稍候重试或者联系工作人员！');
          }
        }).catch((e) => {
          this.$toast.center('修改异常！请联系工作人员！');
        })
      }).catch(() => {

      });
    },
    changeHeadUrl:function (){
      this.headDialog = true;
      this.options.cut_img = this.headUrl;
      this.options.img = this.headUrl;
      this.uploadImageUrl = '';
      this.uploadNew = false;
    },
    uploadAndSave:function (){
      if(!this.uploadImageUrl || this.uploadImageUrl === '' || this.uploadImageUrl.length === 0){
        this.$toast.center("请上传头像!");
        return;
      }
      //上传、保存
      let upload = {"data": this.uploadImageUrl};
      let apiUrl = process.env.APP_API_URL;

      this.$http.post(apiUrl + "/upload/head", upload
      ).then((response) => {
        // console.log(response);
        if(response && response.body && response.body.status === 1){
          let headUrl = response.body.data;
          let params = {"headUrl": headUrl, "userId": this.userId, "uuid": this.uuid};
          let t = new Date().getTime();
          let data = this.common.encodeParams(params, t);

          this.$http.post(apiUrl + "/user/headUrl", {data: data, t: t}
          ).then((response) => {
            // console.log(response);
            if (response.body.status === 1) {
              this.$toast.center('修改成功，审核通过后自动更新');
              let user = response.body.data;
              if(user){
                this.headUrl = user.tempHeadUrl;
                this.headAudit = true;
              }
              this.headDialog = false;
              this.uploadImageUrl = '';
              this.options.img = '';
              this.options.cut_img = '';
            } else if (response.body.status === -3) {
              this.$toast.center('图片含有敏感信息，请调整后重试');
              this.uploadImageUrl = '';
              this.options.img = '';
              this.options.cut_img = '';
            } else  {
              this.$toast.center('修改失败！请稍候重试或者联系工作人员！');
            }
          }).catch((e) => {
            this.$toast.center('修改异常！请联系工作人员！');
          })
        }
      }).catch((e) => {
        this.$toast.center('上传异常！请联系工作人员！');
        this.uploadImageUrl = '';
        this.options.img = '';
        this.options.cut_img = '';
      })
    },
    saveHead:function (){
      let that = this;
      if(!this.uploadNew || !this.options.cut_img || this.options.cut_img === ''){
        this.$toast.center("请上传新头像");
        return;
      }
      this.$refs.cropper.getCropData((data) => {
        that.uploadImageUrl = data;
        that.uploadAndSave();
      })
    },
    //注销登录
    logOff: function () {
      this.$confirm('注销后将清除用户所有站内数据，确认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'l_c_yes',
        cancelButtonClass: 'l_c_no',
        type: 'warning'
      }).then(() => {
        this.$prompt('请输入该账号手机号码后四位', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'l_c_yes',
          cancelButtonClass: 'l_c_no',
          closeOnClickModal:false,
          inputValidator: value => this.checkOffCode(value),
        }).then(({value}) => {
          let params = {"code": this.logOffCode, "userId": this.userId, "uuid": this.uuid};
          let t = new Date().getTime();
          let data = this.common.encodeParams(params, t);
          let apiUrl = process.env.APP_API_URL;

          this.$http.post(apiUrl + "/user/logOff", {data: data, t: t}
          ).then((response) => {
            // console.log(response);
            if (response.body.status === 1) {

              this.$toast.center('注销成功！');
              this.userTool.logout();
              let that = this;
              setTimeout(function () {
                that.openLogin();
              }, 2000)

            } else if (response.body.status === -2) {
              this.$toast.center('账号后四位不匹配！请修改后重试！');
            } else {
              this.$toast.center('注销失败！请稍候重试或者联系工作人员！');
            }
          }).catch((e) => {
            this.$toast.center('注销异常！请联系工作人员！');
          })
        }).catch(() => {

        });
      }).catch(() => {

      });
    },
    checkOffCode: function (value) {
      if (!value || !value.match(/\d{4}/) || value.length !== 4) {
        return '号码格式不正确';
      }
      this.logOffCode = value;
    },
    //退出登录
    exitLogin: function () {
      this.$confirm('确认退出当前用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'l_c_yes',
        cancelButtonClass: 'l_c_no',
        type: 'warning'
      }).then(() => {
        this.userTool.logout();
        /**
         * localStorage.removeItem("book_login");
         localStorage.removeItem("book_login_nickname");
         localStorage.removeItem("book_login_headurl");
         * **/
        this.$toast.center('退出成功！');
        let that = this;
        setTimeout(function () {
          that.openLogin();
        }, 2000)
      }).catch(() => {

      });

    },
    cancel: function () {
      $('#mask').attr("style", "display:none;")
    }
  },
  created() {

  },

  mounted: function () {
    // let that = this;
    // window.addEventListener('popstate', function () {
    //   history.pushState(null, null, document.URL);
    //   that.goBack();
    // });
    this.getDate();
    this.initSrc();

    if(this.common.srcFromWeather()){
      this.fromWeather = true;
    }else{
      this.fromWeather = false;
    }
    var _hmt = _hmt || [];
    var hm = document.createElement("script");
    if(this.fromWeather){
      hm.src = "https://hm.baidu.com/hm.js?da9815d6b4a5d97e58c2156c9b3060cf";
    }else{
      hm.src = "https://hm.baidu.com/hm.js?3e969611694dba0a7e1be8513c061efb";
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);

    let that = this;

    setTimeout(function () {
      that.common.loadAd(402,"nav");
      that.common.loadAd(403,"nav-char");
    }, 600)
  }
}
</script>

<style scoped>
/deep/ .dialog-footer .el-button--primary{
  background-color: #ee7979;
  border-color: #ee7979;
}

/deep/ .dialog-footer .el-button--default{
  background-color: #e0e0e0;
  border-color: #e0e0e0;
}

/deep/ .dialog-footer .el-button--primary span{
  color: white;
}
/deep/ .dialog-footer .el-button--default span{
  color: white;
}

/deep/ .avatar-uploader {
  width: 50%;
  margin-right: 0.1rem;
}

/deep/ .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
/deep/ .el-icon-switch-button {
  color: #ba1515;
}

/deep/ .el-icon-back {
  color: #ba1515;
}

/*/deep/ .el-message-box {*/
/*  width: 72%;*/
/*}*/

/*.el-message-box {*/
/*  width: 72%;*/
/*}*/

/*::v-deep .el-message-box {*/
/*  width: 72%;*/
/*}*/

#header {
  /* width: 100%; */
  padding: 0 .06rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#header h4 {
  font-weight: bold;
  color: #ba1515;
  line-height: .52rem;
  /* margin-left: .12rem; */
}

#header h3 {
  font-weight: bold;
  color: #ba1515;
  font-size: .14rem;
  line-height: .52rem;
  margin-right: .12rem;
}

#header h3 span {
  font-weight: bold;
  color: #ba1515;
  font-size: .14rem;
  line-height: .52rem;
}

#goind {
  width: .26rem;
  height: .26rem;
  background: url(../../static/img/index_icon.png) no-repeat;
  background-size: 100%;
}

#tomin {
  width: .26rem;
  height: .26rem;
  background: url(../../static/img/814.png) no-repeat;
  background-size: 100%;
}

#nickname {
  padding: 0 .4rem;
  height: .8rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: url(../../static/img/index-bg.jpg);
  background-size: 100%;
}

#head {
  width: .6rem;
  height: .6rem;
  background: url(../../static/img/moren.jpg);
  background-size: 100%;
  border-radius: .4rem;
  overflow: hidden;
}

#head_sh{
  background-color: black;
  color: white;
  width: 100%;
  position: relative;
  margin-top: -0.2rem;
  font-size: .1rem;
  text-align: center;
  opacity: .7;
}
/* #head img{
    border-radius:.4rem;
    width:100%;
} */
#name {
  width: 2rem;
  font-size: .15rem;
  color: #fff;
  font-weight: bold;
}

.vip-cnt {
  width: 100%;
  background: #fff;
  margin-top: .1rem;
}

.vip-cnt-li {
  padding: 0 .1rem;
  border-bottom: 1px solid #f9f9f9;
  height: .56rem;
  line-height: .56rem;
  display: flex;
  justify-content: space-between;
}

.cnt-div1 {
  color: #494949;
  font-size: .16rem;
  line-height: .56rem;
}

.cnt-div2 {
  color: #aaaaaa;
  font-size: .12rem;
}

#goind {
  width: .2rem;
  height: .2rem;
  background: url(../../static/img/index_icon.png) no-repeat;
  background-size: 100%;
}

#tomin {
  width: .2rem;
  height: .2rem;
  background: url(../../static/img/exit.png) no-repeat;
  background-size: 100%;
}

#mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background: rgba(71, 71, 71, .71);
  /* display: none; */
}

.cuo {
  padding: 0 .08rem;
  text-align: end;
}

#show1 {
  width: 2.8rem;
  height: 2.4rem;
  background: #fff;
  margin: 0 auto;
  border-radius: .03rem;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -1.2rem;
}

#show2 {
  width: 2.8rem;
  height: 2.7rem;
  background: #fff;
  border-radius: .03rem;
  display: none;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -1.35rem;
}

#show3 {
  width: 2.8rem;
  height: 3.2rem;
  background: #fff;
  border-radius: .03rem;
  display: none;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -1.8rem;
}

#show4 {
  width: 2.8rem;
  height: 1.2rem;
  background: #fff;
  margin: 0 auto;
  border-radius: .03rem;
  display: none;
  position: relative;
  top: 50%; /*偏移*/
  margin-top: -0.6rem;
}

#show5 {
  width: 2.8rem;
  height: 0.8rem;
  background: #fff;
  margin: 2.8rem auto;
  border-radius: .03rem;
  display: none;
}

#content {
  padding: .1rem;
}

.cont {
  width: 100%;
  height: .36rem;
  line-height: .36rem;
  display: flex;
  justify-content: space-around;
  border: 1px solid #efeeee;
  color: #53575a;
}

input::placeholder {
  color: #999999;
}

.cont-d {
  width: .6rem;
  text-align: justify;
  text-justify: distribute-all-lines; /*ie6-8*/
  text-align-last: justify; /* ie9*/
  -moz-text-align-last: justify; /*ff*/
  -webkit-text-align-last: justify; /*chrome 20+*/
  font-size: .15rem;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  /* chrome*/
  .cont-d:after {
    content: ".";
    display: inline-block;
    width: 100%;
    overflow: hidden;
    height: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/vip.vue